import { render, staticRenderFns } from "./MainCollapseMenu.vue?vue&type=template&id=1b369ff8"
import script from "./MainCollapseMenu.vue?vue&type=script&lang=js"
export * from "./MainCollapseMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports